import { Grid } from "@mui/material";
import { isMobile } from "react-device-detect";
import TabPanel from "../../../components/carousel/TabPanel";
import ConteudoQuarta from "./ConteudoQuarta";

const AgendaCarouselTabsQuarta = (props: { activeTab: any, index: number,  dateStartReference: Date, eventListTodayMaisDois: Array<any>, loadEventos: () => void, loading: boolean}) => {

    return (
        <Grid style={{ borderRadius: "6px"}}>
            <TabPanel value={props.activeTab} index={props.index}>
                <ConteudoQuarta index={props.index} activeTab={props.activeTab} dateStartReference={props?.dateStartReference} eventListTodayMaisDois={props?.eventListTodayMaisDois} loadEventos={props?.loadEventos} loading={props?.loading}/>
            </TabPanel>
        </Grid>
    )
}

export default AgendaCarouselTabsQuarta;